import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import "../Form-Dialog/form-dialog.scss";
import "./projectSearchArchive.scss";
import "./projectCopy.scss";
import Project_search_table_row from "../../components/project_search_table_row/project_search_table_row";
import axios from "axios";
import Axios from "axios";
import { Dropdown } from "semantic-ui-react";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { toast } from "react-toastify";
import postalCodes from "postal-codes-js";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";

function FormDialog(props) {
	const [openCustomerInfoDialog, setOpenCustomerInfoDialog] = React.useState(false);
	const [openProjectInfoDialog, setOpenProjectInfoDialog] = React.useState(false);

	// these states are for customer info
	const [FirstName, setFirstName] = useState("");
	const [LastName, setLastName] = useState("");
	const [Address, setAddress] = useState("");
	const [City, setCity] = useState("");
	const [Province, setProvince] = useState("");
	const [DayTimePhone, setDayTimePhone] = useState("");
	const [EmailAddress, setEmailAddress] = useState("");
	const [MobilePhone, setMobilePhone] = useState("");
	const [PostalCode, setPostalCode] = useState("");

	// these states are for project info
	const [ProjectName, setProjectName] = useState("");
	const [Warehouse, setWarehouse] = useState("");
	const [Account, setAccount] = useState("");
	const [ShipTo, setShipTo] = useState("");
	const [ProjectAddress, setProjectAddress] = useState("");
	const [ProjectCity, setProjectCity] = useState("");
	const [ProjectProvince, setProjectProvince] = useState("");
	const [ProjectPostalCode, setProjectPostalCode] = useState("");
	const [ProjectBudget, setProjectBudget] = useState("");
	const [AccountId, setAccountId] = useState("");
	const [CustomerId, setCustomerId] = useState("");

	// We use this to find the level id for the current project so we can copy the project rooms and create new one for the new level id that is representing the new copied project
	const [projectIdForTheProjectWeAreCopying, setProjectIdForTheProjectWeAreCopying] = useState(
		""
	);

	// States used for the drop down component
	const [listOfAccounts, setListOfAccounts] = useState([]);
	const [listOfShipTos, setListOfShipTos] = useState([]);

	const [searchTimeout, setSearchTimeout] = useState("");

	const [redirect, setRedirect] = useState("");

	function stopPropagation(event) {
		event.stopPropagation();
	}

	function handleClickOpenForCustomerInfoDialog(event) {
		setOpenCustomerInfoDialog(true);
	}

	function handleClickOpenForProjectInfoDialog(event) {
		setOpenCustomerInfoDialog(false);
		setOpenProjectInfoDialog(true);
	}

	function handleClose(event) {
		setOpenCustomerInfoDialog(false);
		setOpenProjectInfoDialog(false);
	}

	async function getCustomerInfoToCopyThisProject() {
		handleClickOpenForCustomerInfoDialog();

		// Get contact info for this project for the first form
		let getCustomerInfoToCopyThisProjectAPIUrl =
			props.APIUrl + "/projects/fetch-copy-info";
		let data = {
			projectId: props.projectId
		};
		let getCustomerInfoToCopyThisProjectAPIResponse = await Axios.post(
			getCustomerInfoToCopyThisProjectAPIUrl,
			data
		);

		let customerInformation =
			getCustomerInfoToCopyThisProjectAPIResponse.data.CustomerInformationForCopyingProject;
		if (customerInformation) {
			setFirstName(customerInformation.fname);
			setLastName(customerInformation.lname);
			setAddress(customerInformation.address);
			setCity(customerInformation.city);
			setProvince(customerInformation.province);
			setDayTimePhone(customerInformation.phone_day);
			setEmailAddress(customerInformation.email);
			setMobilePhone(customerInformation.phone_mobile);
			setPostalCode(customerInformation.postal);
		}
	}

	async function getProjectInfoToCopyThisProject() {
		let validationMessage = "";
		if (FirstName === "") {
			validationMessage += translator("Misc", "first_name_error");
		} 
		else if (Province === "") {
			validationMessage += translator("Misc", "province_error");
		} 
		else if (!DayTimePhone && !MobilePhone) { // Check if both numbers are empty
			validationMessage += translator("Misc", "phone_error");
		}
		else if (DayTimePhone.indexOf("_") >= 0 || MobilePhone.indexOf("_") >= 0) { //Check if one of the fields is half-filled
			validationMessage += translator("Misc", "phone_error");
		}
		else if (!!EmailAddress && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(EmailAddress))) {
			validationMessage += translator("Misc", "email_invalid_error");
		} 
		else if (!!PostalCode && postalCodes.validate("ca", PostalCode) !== true) {
			validationMessage += translator("Misc", "postal_code_error");
		}

		if (validationMessage === "") {
			handleClickOpenForProjectInfoDialog();

			let getCustomerInfoToCopyThisProjectAPIUrl =
				props.APIUrl + "/projects/fetch-copy-info";
			let data = {
				projectId: props.projectId
			};
			let getCustomerInfoToCopyThisProjectAPIResponse = await Axios.post(
				getCustomerInfoToCopyThisProjectAPIUrl,
				data
			); // name of this variable is incorrect it should be getProjectInfo
			let projectInformation =
				getCustomerInfoToCopyThisProjectAPIResponse.data.ProjectInformation;

			setProjectIdForTheProjectWeAreCopying(projectInformation.id); // we need this to copy the room name for the new project we are copying
			setProjectName(projectInformation.title);
			setWarehouse(projectInformation.warehouse);
			setAccount(projectInformation.account_name);
			setShipTo(projectInformation.ship_to);
			setProjectAddress(projectInformation.address);
			setProjectCity(projectInformation.city);
			setProjectProvince(projectInformation.province);
			setProjectPostalCode(projectInformation.postal);
			setProjectBudget(projectInformation.budget);
			setAccountId(projectInformation.account_id);
			setCustomerId(projectInformation.customer_id);

			// display the current project account name
			await setListOfAccounts([
				{
					text: projectInformation.account_name,
					value: projectInformation.account_id
				}
			]);
			await getShipTosForThisAccountId(projectInformation.account_id); //passing the account id instead of async waiting for state to change
		} else {
			toast.error(validationMessage, {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		}
	}
	// =================================================
	async function callAjax(route, data) {
		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");

		let APIResponse = await Axios.post(props.APIUrl + route, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			return false;
		}
		return APIResponse.data;
	};

	async function getAccounts(query) {
		let route = "/emco_settings/search-accounts";
		let response = await callAjax(route, { q: query });
		if (!response) return;
		if (!response.hasOwnProperty("data")) setListOfAccounts([]);
		else setListOfAccounts(response.data.map(account => ({ text: account.Name + ' | ' + account.CustomerNumber, value: account.CustomerNumber })));
	};
	// =================================================

	function searchAccounts(query) {
		window.clearTimeout(searchTimeout);

		setSearchTimeout(window.setTimeout(getAccounts, 500, query));
	}

	async function getShipTosForThisAccountId(eventTargetValue, accountParam = null) {
		if (eventTargetValue && listOfAccounts.length) {
			// we also need to get the account name to update the database
			let selectedAccountIndex = listOfAccounts.findIndex(
				account => account.value === eventTargetValue
			);

			await setAccount(listOfAccounts[selectedAccountIndex].text);
			await setAccountId(eventTargetValue);
			await setShipTo("");
		}

		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getShipToAPIUrl = props.APIUrl + "/projects/fetch-ship-to";

		const data = {
			token,
			trendId,
			projectAccountId: eventTargetValue ? eventTargetValue : AccountId,
			warehouse: Warehouse
		};

		const getShipToAPIResponse = await Axios.post(getShipToAPIUrl, data);
		let listOfShipTosFromTrend = getShipToAPIResponse.data.listOfShipTosFromTrend;
		const listOfShipTos = [];

		// The reason we have an else statement here is because it crashes when you loop through a non array
		// so the else statement does not have a for loop.
		if (Array.isArray(listOfShipTosFromTrend)) {
			for (let i = 0; i < listOfShipTosFromTrend.length; i++) {
				let formatDataForDropDown = {
					text:
						listOfShipTosFromTrend[i].ShipTo +
						" | " +
						listOfShipTosFromTrend[i].CustomerNumber +
						" | " +
						listOfShipTosFromTrend[i].Name,
					value: listOfShipTosFromTrend[i].ShipTo
				};

				listOfShipTos.push(formatDataForDropDown);
			}
		} else if (listOfShipTosFromTrend === undefined) {
			// DO NOTHING. I know this seems sloppy but I mean it really isn't a big deal and not worth my time to find a logical way for ONLY and if and else
			// this means there are no ship tos for this account id. The reason i have this is because i don't want to the program to crash saying something like .ShipTo is not a property.
		} else {
			let formatDataForDropDown = {
				text: listOfShipTosFromTrend.ShipTo + " | " + listOfShipTosFromTrend.CustomerNumber,
				value: listOfShipTosFromTrend.ShipTo
			};

			listOfShipTos.push(formatDataForDropDown);
		}
		await setListOfShipTos(listOfShipTos);
	}

	async function copyProject() {
		let validationMessage = "";
		if (ProjectName === "") {
			validationMessage += "please enter the project name \n";
		} else if (Warehouse === "") {
			validationMessage += translator("Misc", "project_create_warehouse_error");
		} else if (Account === "") {
			validationMessage += translator("Misc", "project_create_account_error");
		} 
		else if (!!PostalCode && postalCodes.validate("ca", PostalCode) !== true) {
			validationMessage += translator("Misc", "postal_code_error");
		}

		if (validationMessage === "") {
			let copyProjectAPIUrl = props.APIUrl + "/projects/copy";
			let data = {
				//project info
				projectTitle: ProjectName,
				projectWarehouse: Warehouse,
				projectAccount_name: Account,
				projectShip_to: ShipTo,
				projectAddress: ProjectAddress,
				projectCity: ProjectCity,
				projectProvince: ProjectProvince,
				projectPostal: ProjectPostalCode,
				projectBudget: ProjectBudget,
				account_id: AccountId,
				customer_id: CustomerId,
				created_by: localStorage.getItem("trendId"),
				edited_by: localStorage.getItem("trendId"),
				archived: 0, // Matt said that when ever you copy projects it will always become active.
				projectIdForTheProjectWeAreCopying: projectIdForTheProjectWeAreCopying,

				// contact info
				customerFirstName: FirstName,
				customerLastName: LastName,
				customerAddress: Address,
				customerCity: City,
				customerProvince: Province,
				customerDayTimePhone: DayTimePhone,
				customerEmailAddress: EmailAddress,
				customerMobilePhone: MobilePhone,
				customerPostalCode: PostalCode
			};

			let copyProjectAPIResponse = await Axios.post(copyProjectAPIUrl, data);

			reRenderProjectSearchResultsForCopyingAndArchiving();

			// toasting was not working in the archived tab only for the active tab.So, I decided to just use alert instead because Matt and Mark is rushing me.
			toast.success(translator("Misc", "project_copy_success"), {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
			handleClose();
		} else {
			// toasting was not working in the archived tab only for the active tab. So, I decided to just use alert instead because Matt and Mark is rushing me.
			toast.error(validationMessage, {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		}
	}

	async function reRenderProjectSearchResultsForCopyingAndArchiving() {
		let getAllProjectsUrl = props.APIUrl + "/projects?limit=10&skip=0";
		try {
			const getAllProjectsResponse = await axios.get(getAllProjectsUrl);
			const projects = getAllProjectsResponse.data.firstTenEmcoProjects;

			const storeProjects = await projects.map((project, index) => (
				<Project_search_table_row
					projectNumber={index + 1}
					projectId={project.id}
					projectTitle={project.title}
					account={project.account_id}
					accountName={project.account_name}
					shipTo={project.ship_to}
					warehouse={project.warehouse}
					teamMember={project.edited_by} //didn't know what the team member value should be so i assumed it was this
					dateCreated={project.date_added ? project.date_added.slice(0, -9) : null}
					amount={project.budget}
				/>
			));
			await props.reRenderSearchResults();
		} catch (e) {
			console.log("here is the error message ", e);
		}
	}
	return (
		<div onClick={stopPropagation}>
			{redirect}
			<Button variant="outlined" color="primary" onClick={getCustomerInfoToCopyThisProject}>
				<Translated section="Misc" label="copy_label" />
			</Button>
			<Dialog
				open={openCustomerInfoDialog}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Misc" label="project_copy_customer_dialog_title" />{" "}
					<Button id="set-price-close-button" onClick={handleClose} color="primary">
						<i class="fa fa-window-close fa-2x" aria-hidden="true" />
					</Button>
				</DialogTitle>
				<DialogContent style={{ width: "50rem" }}>
					<DialogContentText>
						<Translated section="Misc" label="project_copy_customer_dialog_copy" />
					</DialogContentText>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Misc" label="first_name_label" /> *
						</label>
						<input
							type="text"
							class="form-control  project-copy-input project-setup-mandatory"
							onChange={event => setFirstName(event.target.value)}
							value={FirstName ? FirstName : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Misc" label="last_name_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setLastName(event.target.value)}
							value={LastName ? LastName : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="address_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setAddress(event.target.value)}
							value={Address ? Address : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="city_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setCity(event.target.value)}
							value={City ? City : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="province_label" /> *
						</label>
						<select
							class="form-control  project-copy-input project-setup-mandatory"
							type="button"
							id="dropdownMenuButton"
							onChange={event => setProvince(event.target.value)}
							value={Province}
						>
							<option value="">
								{translator("Misc", "province_error")} &#8964;
							</option>
							<option value="AB">{translator("Misc", "province_ab")}</option>
							<option value="BC">{translator("Misc", "province_bc")}</option>
							<option value="MB">{translator("Misc", "province_mb")}</option>
							<option value="NB">{translator("Misc", "province_nb")}</option>
							<option value="NL">{translator("Misc", "province_nl")}</option>
							<option value="NT">{translator("Misc", "province_nt")}</option>
							<option value="NS">{translator("Misc", "province_ns")}</option>
							<option value="NU">{translator("Misc", "province_nu")}</option>
							<option value="ON">{translator("Misc", "province_on")}</option>
							<option value="PE">{translator("Misc", "province_pe")}</option>
							<option value="QC">{translator("Misc", "province_qc")}</option>
							<option value="SK">{translator("Misc", "province_sk")}</option>
							<option value="YT">{translator("Misc", "province_yt")}</option>
						</select>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="postal_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setPostalCode(event.target.value)}
							value={PostalCode ? PostalCode : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="email_label" />
						</label>
						<input
							type="email"
							class="form-control  project-copy-input"
							onChange={event => setEmailAddress(event.target.value)}
							value={EmailAddress ? EmailAddress : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="daytime_label" /> *
						</label>
						<InputMask 
							mask="999-999-9999"
							value={DayTimePhone ? DayTimePhone : ""}
							class="form-control project-copy-input project-setup-mandatory"
							placeholder={translator("Project Setup", "daytime_label")}
							onChange={event => setDayTimePhone(event.target.value)}
						/>
					</div>
					<div className={"project-setup-or project-copy-input"}>{translator("Misc", "or_label")}</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="mobile_label" /> *
						</label>
						<InputMask 
							mask="999-999-9999"
							value={MobilePhone ? MobilePhone : ""}
							class="form-control project-copy-input project-setup-mandatory"
							placeholder={translator("Project Setup", "mobile_label")}
							onChange={event => setMobilePhone(event.target.value)}
						/>
					</div>
					<div className="mandatory-notice">
						<span className="mandatory-box"></span><span className="mandatory-label">* {translator("Misc", "mandatory_fields")}</span>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={getProjectInfoToCopyThisProject} color="primary">
						<Translated section="Project Setup" label="confirm_btn" />
					</Button>
					<Button onClick={handleClose} color="primary">
						<Translated section="Misc" label="close_btn" />
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={openProjectInfoDialog}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Misc" label="project_copy_account_dialog_title" />{" "}
				</DialogTitle>
				<DialogContent style={{ width: "50rem" }}>
					<DialogContentText>
						<Translated section="Misc" label="project_copy_account_dialog_copy" />
					</DialogContentText>

					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="project_name_label" /> *
						</label>
						<input
							type="text"
							class="form-control  project-copy-input project-setup-mandatory"
							onChange={event => setProjectName(event.target.value)}
							value={ProjectName ? ProjectName : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="warehouse_label" /> *
						</label>
						<input
							type="text"
							class="form-control  project-copy-input project-setup-mandatory"
							onChange={event => setWarehouse(event.target.value)}
							value={Warehouse ? Warehouse : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="account_label" /> *
						</label>
						<Dropdown
							className="form-control  project-copy-input project-setup-mandatory"
							style={{ width: "75%" }}
							placeholder={translator("Misc", "account_label")}
							fluid
							search={(options, query) => options}
							selection
							options={listOfAccounts}
							onChange={(event, { value }) => getShipTosForThisAccountId(value)}
							onSearchChange={(e, d) => {
								searchAccounts(d.searchQuery);
							}}
							value={AccountId}
						/>
					</div>

					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Misc" label="ship_to_label" />
						</label>
						<Dropdown
							className="form-control  project-copy-input"
							style={{ width: "75%" }}
							class="project-copy-input"
							placeholder={
								listOfShipTos.length > 0
									? translator("Misc", "choose_ship_to_btn")
									: translator("Misc", "no_ship_to_with_account")
							}
							fluid
							selection
							options={listOfShipTos}
							onChange={(event, { value }) => setShipTo(value)}
							value={ShipTo}
						/>
					</div>

					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="project_address_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setProjectAddress(event.target.value)}
							value={ProjectAddress ? ProjectAddress : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="city_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setProjectCity(event.target.value)}
							value={ProjectCity ? ProjectCity : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="province_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setProjectProvince(event.target.value)}
							value={ProjectProvince ? ProjectProvince : ""}
						/>
					</div>
					<div class="form-group project-copy-form-group">
						<label>
							<Translated section="Project Setup" label="postal_label" />
						</label>
						<input
							type="text"
							class="form-control  project-copy-input"
							onChange={event => setProjectPostalCode(event.target.value)}
							value={ProjectPostalCode ? ProjectPostalCode : ""}
						/>
					</div>
					<div className="mandatory-notice">
						<span className="mandatory-box"></span><span className="mandatory-label">* {translator("Misc", "mandatory_fields")}</span>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={copyProject} color="primary">
						<Translated section="Misc" label="confirm_btn" />
					</Button>
					<Button onClick={handleClose} color="primary">
						<Translated section="Misc" label="close_btn" />
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
